import {isDesktop} from "../../webpack/modules/devices";
import {windowScrollEvent} from "../../webpack/modules/events";

if (document.querySelector('.left-menu-v2')) {
    if (isDesktop()) {
        calculateLeftMenuHeight();

        let headerMessagesVisible = false;
        windowScrollEvent(function() {
            let headerMessages = document.querySelector('.header-messages');
            if (!headerMessages) return;
            let rect = headerMessages.getBoundingClientRect();
            let currentHeaderMessagesVisible = rect.top < window.innerHeight && rect.bottom > 0;

            //RECALCULATE LEFT MENU HEIGHT ONLY IF VISIBILITY CHANGED
            if (headerMessagesVisible !== currentHeaderMessagesVisible) {
                headerMessagesVisible = currentHeaderMessagesVisible;
                if (headerMessagesVisible) calculateLeftMenuHeight();
                else calculateLeftMenuHeightWithoutMessages();
            }
        });
    }
}

function calculateLeftMenuHeight()
{
    document.querySelectorAll('.left-menu-v2').forEach(function(leftMenu) {
        let header = document.querySelector('header');
        let headerMessages = document.querySelector('.header-messages');
        let headerHeight = header.offsetHeight;

        if (headerMessages) headerHeight += headerMessages.offsetHeight;
        leftMenu.style.height = (window.innerHeight - headerHeight) + 'px';
    });
}

function calculateLeftMenuHeightWithoutMessages()
{
    document.querySelectorAll('.left-menu-v2').forEach(function(leftMenu) {
        let header = document.querySelector('header');
        let headerHeight = header.offsetHeight;
        leftMenu.style.height = (window.innerHeight - headerHeight) + 'px';
    });
}